module.exports = __webpack_public_path__ + "img/l1.2d97cadd.jpg";